import { ComponentChildren, JSX } from 'preact';

type ContainerWrapperProps = {
  children: ComponentChildren;
  style?: Record<string, any>;
  class?: string;
};

export function ContainerWrapper({
  children,
  style,
  class: className,
}: ContainerWrapperProps): JSX.Element {
  return (
    <div class={`@lg:py-16 @sm:py-12 py-8 px-2 @sm:px-4 @lg:px-6 ${className || ''}`} style={style}>
      <div class="max-w-6xl mx-auto">{children}</div>
    </div>
  );
}

/**
 * The new landing page builder broke padding for all blocks. We'll add
 * this around the legacy blocks to have some kind of horizontal padding.
 */
export function LegacyContainerWrapper({
  children,
  style,
  class: className,
}: ContainerWrapperProps): JSX.Element {
  return (
    <div class={`px-2 @sm:px-4 @lg:px-6 ${className || ''}`} style={style}>
      {children}
    </div>
  );
}
